<template>
<div class="">
隐私政策
</div>
</template>

<script>
export default {
    name:"",
    data() {
        return {

        }
    },
    created() {

    },
    mounted() {

    }
}
</script>
<style scoped>

</style>